import { Select, MenuItem, Box, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from 'hooks';
import { setTimezone } from 'store/applicationReducer';

const TIMEZONES = [
    { value: 'Asia/Seoul', label: 'Asia/Seoul' },
    { value: 'Asia/Taipei', label: 'Asia/Taipei' },
];

// React pages that support timezone switching
const REACT_PAGES = [
    '/search/member',
    '/billing/contract',
    '/billing/statement-test',
    '/history/push',
    '/history/event',
    '/history/platform',
    '/history/account',
    '/history/storage',
    '/manage/forceUpdate',
    '/manage/mail',
    '/dashboard',
];

const TimezoneSelector = () => {
    const dispatch = useAppDispatch();
    const timezone = useAppSelector((state) => state.application.timezone);
    const location = useLocation();

    const isReactPage = REACT_PAGES.some(path => location.pathname.startsWith(path));
    if (!isReactPage) return null;

    return (
        <Box sx={{ mr: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <Typography sx={{ fontSize: '10px', color: 'text.secondary', lineHeight: 1, mb: 0.3 }}>
                Timezone
            </Typography>
            <Select
                value={timezone}
                onChange={(e) => dispatch(setTimezone(e.target.value))}
                size="small"
                sx={{ minWidth: 120, height: 30, fontSize: '0.8rem' }}
            >
                {TIMEZONES.map(tz => (
                    <MenuItem key={tz.value} value={tz.value} sx={{ fontSize: '0.8rem' }}>{tz.label}</MenuItem>
                ))}
            </Select>
        </Box>
    );
};

export default TimezoneSelector;
